import React, { Component } from 'react';
import { Button } from 'primereact/button';

class ActionWidget extends Component {

    renderItems = (items = []) => {
        return items.map((item, index) => (
            <div
                key={index}
                className="action-item-row"
            >
                <span>{item.name}</span>

                <span>{item.value}</span>
            </div>
        ));
    };

    render() {

        const {
            data = [],
            buttonLabel = 'Action',
            onActionClick
        } = this.props;

        return (
            <div className="action-widget">

                {
                    data.map(card => (

                        <div
                            key={card.id}
                            className="action-card"
                        >

                            <div className="action-card-header">

                                <div className="supplier-name">

                                    <i className="pi pi-minus" />

                                    <span>
                                        {card.title}
                                    </span>

                                </div>

                                <Button
                                    label={buttonLabel}
                                    className="raise-po-btn"
                                    onClick={() =>
                                        onActionClick &&
                                        onActionClick(card)
                                    }
                                />

                            </div>

                            <div className="action-card-body">

                                {
                                    this.renderItems(
                                        card.items
                                    )
                                }

                            </div>

                        </div>

                    ))
                }

            </div>
        );
    }
}

export default ActionWidget;